import React, { Fragment, useEffect, useState } from "react"
import {
  Button,
  CardTitle,
  Col,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import PropTypes from "prop-types"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import "react-datepicker/dist/react-datepicker.css"
import Select from "react-select"
import API from "../../api"
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

const TransfertEtudiant = props => {
  const [niveau, setNiveau] = useState([])
  const [selectNiveau, setSelectNiveau] = useState("")
  const [cycle, setCycle] = useState([
    { value: 1, label: "Licence" },
    { value: 2, label: "Mastère" },
  ])
  const [selectCycle, setSelectCycle] = useState("")
  const [cyclePermuter, setCyclePermuter] = useState([
    { value: 1, label: "Licence" },
    { value: 2, label: "Mastère" },
  ])
  const [selectCyclePermuter, setSelectCyclePermuter] = useState("")
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [selectSemestre, setSelectSemestre] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [date, setDate] = useState(new Date())
  const [quart, setQuart] = useState([])
  const [selectQuart, setSelectQuart] = useState("")
  const [groupe, setGroupe] = useState([])
  const [selectGroupe, setSelectGroupe] = useState("")
  const [matiere, setMatiere] = useState([])
  const [selectMatiere, setSelectMatiere] = useState("")
  const [semestrePermuter, setSemestrePermuter] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [selectSemestrePermuter, setSelectSemestrePermuter] = useState("")
  const [niveauPermuter, setNiveauPermuter] = useState([])
  const [selectNiveauPermuter, setSelectNiveauPermuter] = useState("")
  const [specialitePermuter, setSpecialitePermuter] = useState([])
  const [selectSpecialitePermuter, setSelectSpecialitePermuter] = useState("")
  const [datePermuter, setDatePermuter] = useState(new Date())
  const [quartPermuter, setQuartPermuter] = useState([])
  const [selectQuartPermuter, setSelectQuartPermuter] = useState("")
  const [groupePermuter, setGroupePermuter] = useState([])
  const [selectGroupePermuter, setSelectGroupePermuter] = useState("")
  const [matierePermuter, setMatierePermuter] = useState([])
  const [selectMatierePermuter, setSelectMatierePermuter] = useState("")
  const [arrayDetail, setArrayDetail] = useState([])
  const [arrayDetailPermuter, setArrayDetailPermuter] = useState([])
  const [modal, setModal] = useState(false)
  const [modalS2, setModalS2] = useState(false)
  const [checkedItems, setCheckedItems] = useState({})
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  useEffect(async () => {
    const res = await API.get("niveau/select").then(res => {
      setNiveau(res.data.Niveau)
      setNiveauPermuter(res.data.Niveau)
    })
  }, [])
  const getSemestre = async e => {
    setSelectSemestre(e)
    setSelectNiveau("")
    setSelectSpecialite("")
    setSelectGroupe("")
    setArrayDetail([])
  }
  const getSemestrePermuter = async e => {
    setSelectSemestrePermuter(e)
    setSelectNiveauPermuter("")
    setSelectSpecialitePermuter("")
    setSelectGroupePermuter("")
    setArrayDetailPermuter([])
  }
  const getSpecialite = async e => {
    setSelectNiveau(e)
    setSelectSpecialite("")
    setSelectGroupe("")
    setArrayDetail([])
    const res = await API.post("specialite/get_by_cycle_niveau_semestre", {
      niveau_id: e.value,
      semestre_id: selectSemestre.value,
      cycle_id: selectCycle.value,annee_id
    }).then(res => {
      setSpecialite(res.data.specialites)
    })
  }
  const getSpecialitePermuter = async e => {
    setSelectNiveauPermuter(e)
    setSelectSpecialitePermuter("")
    setSelectGroupePermuter("")
    setArrayDetailPermuter([])
    const res = await API.post("specialite/get_by_cycle_niveau_semestre", {
      niveau_id: e.value,
      semestre_id: selectSemestrePermuter.value,
      cycle_id: selectCyclePermuter.value,annee_id
    }).then(res => {
      setSpecialitePermuter(res.data.specialites)
    })
  }
  const getGroupe = async e => {
    setSelectSpecialite(e)
    setSelectGroupe("")
    setArrayDetail([])
    const res = await API.post("specialite/get_grp", {
      annee_id,
      niveau_id: selectNiveau.value,
      semestre_id: selectSemestre.value,
      cycle_id: selectCycle.value,
      specialite_id: e.value,
    }).then(res => {
      setGroupe(res.data.groups)
    })
  }
  const getEtudiant = async e => {
    setSelectGroupe(e)
    setArrayDetail([])
    const res = await API.post("specialite/get_grp_etudiant", {
      annee_id,
      semestre_id: selectSemestre.value,
      group_id: e.value,
    }).then(res => {
      setArrayDetail(res.data.etudiants)
      // Initialiser checkedItems basé sur el.etat
      const initialCheckedItems = {};
      res.data.etudiants.forEach((el, index) => {
        initialCheckedItems[index] = el.etat == 1;
      });
      setCheckedItems(initialCheckedItems);
    })
  }
  const getEtudiantPermuter = async e => {
    setSelectGroupePermuter(e)
    setArrayDetailPermuter([])
    const res = await API.post("specialite/get_grp_etudiant", {
      annee_id,
      semestre_id: selectSemestrePermuter.value,
      group_id: e.value,
    }).then(res => {
      setArrayDetailPermuter(res.data.etudiants)
    })
  }
  const getCycle = async e => {
    setSelectCycle(e)
    setSelectSemestre("")
    setSelectNiveau("")
    setSelectSpecialite("")
    setSelectGroupe("")
    setArrayDetail([])
  }
  const getCyclePermuter = async e => {
    setSelectCyclePermuter(e)
    setSelectSemestrePermuter("")
    setSelectNiveauPermuter("")
    setSelectSpecialitePermuter("")
    setSelectGroupePermuter("")
    setArrayDetailPermuter([])
  }
  const getGroupePermuter = async e => {
    setSelectSpecialitePermuter(e)
    setSelectGroupePermuter("")
    setArrayDetailPermuter([])
    const res = await API.post("specialite/get_grp", {
      annee_id,
      niveau_id: selectNiveauPermuter.value,
      semestre_id: selectSemestrePermuter.value,
      cycle_id: selectCyclePermuter.value,
      specialite_id: e.value,
    }).then(res => {
      setGroupePermuter(res.data.groups)
    })
  }
  // const save = async () => {
  //   API.post("specialite/transfert", {
  //     group_id: selectGroupe.value,
  //     group_permuter_id: selectGroupePermuter.value,
  //     semestre_id: selectSemestre.value,
  //     semestre_permutation_id: selectSemestrePermuter.value,
  //     annee_id,
  //     user_id,
  //   }).then(res => {
  //     props.setSection(1)
  //   })
  // }
  const save = async () => {
    const showCheckboxColumn =
      (selectCycle.value == 2 && selectNiveau.value == 2) ||
      (selectCycle.value == 1 && selectNiveau.value == 3 && selectSpecialite.value == 2) ||
      (selectCycle.value == 1 && selectNiveau.value == 3 && selectSpecialite.value == 3);

    let etudiantsData;

    if (showCheckboxColumn) {
      // Cas 1: Checkboxes affichés -> utiliser les sélections
      etudiantsData = arrayDetail.map((etudiant, index) => ({
        etudiant_id:etudiant.etudiant_id,
        etat: checkedItems[index] ? 1 : 0,
      }));
    } else {
      // Cas 2: Pas de checkboxes -> tous les étudiants avec état 1
      etudiantsData = arrayDetail.map(etudiant => ({
        etudiant_id: etudiant.etudiant_id,
        etat: 1, // Tous sélectionnés
      }));
    }

    API.post("specialite/transfert", {
      group_id: selectGroupe.value,
      group_permuter_id: selectGroupePermuter.value,
      semestre_id: selectSemestre.value,
      semestre_permutation_id: selectSemestrePermuter.value,
      annee_id,
      user_id,
      etudiants: etudiantsData,
    }).then(res => {
      props.setSection(1);
    });
  };
  const deleteSmestre1 = async () => {
    API.post("specialite/Deletetransfert", {
      group_id: selectGroupe.value,
      semestre_id: selectSemestre.value,
      annee_id,
      user_id,
    }).then(res => {
      props.setSection(1)
    })
  }
  const deleteSmestre2 = async () => {
    API.post("specialite/Deletetransfert", {
      group_id: selectGroupePermuter.value,
      semestre_id: selectSemestrePermuter.value,
      annee_id,
      user_id,
    }).then(res => {
      props.setSection(1)
    })
  }
  const toggle = id => {
    setModal(!modal)
  }
  const toggleS2 = id => {
    setModalS2(!modalS2)
  }
  const handleCheckboxChange = index => {
    setCheckedItems(prev => ({
      ...prev,
      [index]: !prev[index],
    }))
  }
  return (
    <React.Fragment>
      <Row>
        <Form>
          <Row>
            <Col lg="6">
              <fieldset style={{ border: "1px solid #ccc", padding: "10px" }}>
                <legend style={{ color: "#556ee6" }}>
                  Choisir le groupe de semestre 1
                </legend>
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Cycle : </Label>
                      <Select
                        options={cycle}
                        isSearchable={true}
                        value={selectCycle}
                        onChange={e => getCycle(e)}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Semestre :{" "}
                      </Label>
                      <Select
                        options={semestre}
                        isSearchable={true}
                        value={selectSemestre}
                        onChange={e => getSemestre(e)}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Niveau : </Label>
                      <Select
                        options={niveau}
                        isSearchable={true}
                        value={selectNiveau}
                        onChange={e => getSpecialite(e)}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Spécialité :{" "}
                      </Label>
                      <Select
                        options={specialite}
                        isSearchable={true}
                        value={selectSpecialite}
                        onChange={e => getGroupe(e)}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Groupe : </Label>
                      <Select
                        options={groupe}
                        isSearchable={true}
                        value={selectGroupe}
                        onChange={e => getEtudiant(e)}
                      />
                    </div>
                  </Col>
                </Row>

                {selectGroupe !== "" ? (
                  <Fragment>
                    <Row>
                      <Col lg={12}>
                        <CardTitle style={{ color: "#088d29" }} className="h4">
                          {"Liste des étudiants de cette groupe de semestre 1"}
                        </CardTitle>
                        <table className="table table-bordered text-center">
                          <thead>
                          <tr>
                            {((selectCycle.value == 2 && selectNiveau.value ==2) ||
                              (selectCycle.value == 1 && selectNiveau.value == 3 && selectSpecialite.value == 2) ||
                              (selectCycle.value == 1 && selectNiveau.value == 3 && selectSpecialite.value == 3)) && (
                              <th style={{ padding: "0" }}>
                                {/* Case à cocher pour sélectionner tous */}
                                <input
                                  type="checkbox"
                                  onChange={e => {
                                    const isChecked = e.target.checked
                                    const newCheckedItems = {}
                                    arrayDetail.forEach((_, idx) => {
                                      newCheckedItems[idx] = isChecked
                                    })
                                    setCheckedItems(newCheckedItems)
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "5px",
                                  }}
                                />
                              </th>
                            )}
                            <th style={{ padding: "0" }}>N°</th>
                            <th style={{ padding: "0" }}>
                              <strong>CIN</strong>
                            </th>
                            <th style={{ padding: "0" }}>
                              <strong>Etudiant</strong>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          {arrayDetail.map((el, index) => (
                            <tr key={index}>
                              {((selectCycle.value == 2 && selectNiveau.value == 2) ||
                                (selectCycle.value == 1 && selectNiveau.value == 3 && selectSpecialite.value == 2) ||
                                (selectCycle.value == 1 && selectNiveau.value == 3 && selectSpecialite.value == 3)) && (
                                <td style={{ padding: "0" }}>
                                  <input
                                    type="checkbox"
                                    checked={checkedItems[index] || false}
                                    onChange={() => handleCheckboxChange(index)}
                                    style={{ cursor: "pointer" }}
                                  />
                                </td>
                              )}
                              <td style={{ padding: "0" }}>{index + 1}</td>
                              <td style={{ padding: "0" }}>{el.cin}</td>
                              <td style={{ padding: "0" }}>
                                {el.nom} {el.prenom}
                              </td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <div className="text-center mt-4">
                          <button
                            type="button"
                            className="btn btn-danger "
                            onClick={toggle}
                          >
                            {
                              "Supprimer l'affectation de l'étudiant de semestre 1"
                            }
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Fragment>
                ) : null}
              </fieldset>
            </Col>
            <Col lg="6">
              <fieldset style={{ border: "1px solid #ccc", padding: "10px" }}>
                <legend style={{ color: "#556ee6" }}>
                  Choisir le groupe de semestre 2
                </legend>
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Cycle : </Label>
                      <Select
                        options={cyclePermuter}
                        isSearchable={true}
                        value={selectCyclePermuter}
                        onChange={e => getCyclePermuter(e)}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Semestre :{" "}
                      </Label>
                      <Select
                        options={semestrePermuter}
                        isSearchable={true}
                        value={selectSemestrePermuter}
                        onChange={e => getSemestrePermuter(e)}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Niveau : </Label>
                      <Select
                        options={niveauPermuter}
                        isSearchable={true}
                        value={selectNiveauPermuter}
                        onChange={e => getSpecialitePermuter(e)}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Spécialité :{" "}
                      </Label>
                      <Select
                        options={specialitePermuter}
                        isSearchable={true}
                        value={selectSpecialitePermuter}
                        onChange={e => getGroupePermuter(e)}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Groupe : </Label>
                      <Select
                        options={groupePermuter}
                        isSearchable={true}
                        value={selectGroupePermuter}
                        onChange={e => getEtudiantPermuter(e)}
                      />
                    </div>
                  </Col>
                </Row>

                {selectGroupePermuter !== "" ? (
                  <Fragment>
                    <Row>
                      <Col lg={12}>
                        <CardTitle style={{ color: "#088d29" }} className="h4">
                          {"Liste des étudiants de cette groupe de semestre 2"}
                        </CardTitle>
                        <table className="table table-bordered text-center">
                          <tbody>
                            <tr>
                              <td style={{ padding: "0" }}></td>
                              <td style={{ padding: "0" }}>
                                <strong>CIN</strong>
                              </td>
                              <td style={{ padding: "0" }}>
                                <strong>Etudiant</strong>
                              </td>
                            </tr>
                            {arrayDetailPermuter.map((el, index) => (
                              <tr key={index}>
                                <td style={{ padding: "0" }}>{index + 1}</td>
                                <td style={{ padding: "0" }}>{el.cin}</td>
                                <td style={{ padding: "0" }}>
                                  {el.nom} {el.prenom}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <div className="text-center mt-4">
                          <button
                            type="button"
                            className="btn btn-danger "
                            onClick={toggleS2}
                          >
                            {
                              "Supprimer l'affectation de l'étudiant de semestre 2"
                            }
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Fragment>
                ) : null}
              </fieldset>
            </Col>
          </Row>
        </Form>
        {selectGroupe !== "" && selectGroupePermuter !== "" ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  Annuler
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button type="button" className="btn btn-pink " onClick={save}>
                  TRANSFERT
                </button>
              </div>
            </Col>
          </div>
        ) : null}
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {"Suppression l'affectation des étudiants de semestre 1"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {
                  "Êtes-Vous sûr de vouloir supprimer l'affectation des étudiants de semestre 1"
                }
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={deleteSmestre1}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {"Oui"}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Non"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalS2} toggle={toggleS2} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleS2}
          tag="h4"
        >
          {"Suppression l'affectation des étudiants de semestre 2"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {
                  "Êtes-Vous sûr de vouloir supprimer l'affectation des étudiants de semestre 2"
                }
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={deleteSmestre2}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {"Oui"}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleS2}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Non"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}
export default TransfertEtudiant
TransfertEtudiant.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  semestre: PropTypes.object,
  t: PropTypes.object,
}
